module.exports = __webpack_public_path__ + "static/media/college_campus.da6939c3.jpg";